import React from 'react';
import styled from 'styled-components';

const StyledFooter = styled.footer`
  margin-top: 200px;
`;

export default function Footer() {
  return (
    <StyledFooter>
      &copy; Maggie Bencivenga {new Date().getFullYear()}
    </StyledFooter>
  );
}
